import React, { Component } from 'react';

import Collapsible from 'react-collapsible';
import { connect } from 'react-redux';
import MenuHeader from 'components/shared/MenuHeader';
import Auth from 'j-toker';
import { apiGet, apiPost } from 'helpers/ApiHelper';
import { getTranslatedString } from 'helpers/i18n';
import styled from 'styled-components';
import Spacer from 'components/ui/Spacer';
import CtaPrimary from 'components/ui/CtaPrimary';
import { Table, Tag } from 'antd';
import { toFriendlyDateTimeString } from 'helpers/Formatter';
import CircularProgress from '@material-ui/core/CircularProgress';

const StyledCircularProgress = styled(CircularProgress)`
  position: relative;
  top: 5px;
  margin-left: 8px;
`;

const StyledButton = styled(CtaPrimary)`
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  padding-top: 1px;
  font-family: Circular-Bold;
`;

const StyledTable = styled(Table)`
  .ant-table-title {
    font-family: 'circular-bold';
    font-size: 1.1rem;
    padding: 8px 0;
  }
  .ant-table-column-title {
    font-family: 'circular-bold';
  }
  .ant-table-tbody > tr > td {
    padding: 8px 16px;
  }
  .ant-table-thead > tr > th {
    padding: 8px 16px;
  }
`;

const StyledTag = styled(Tag)`
  float: right;
`;

export default connect((store) => {
  return {
    userType: store.userTypes.userType,
  };
})(
  class Integrations extends Component {
    constructor(props) {
      super(props);
      this.state = {
        yardiIsOpen: true,
        yardiClient: null,
        loadingIntegrations: false,
      };
    }

    componentDidMount() {
      this.getIntegrations();
    }

    handlePullingProperties = () => {
      apiPost(Auth.getApiUrl() + `/landlords/yardi_clients/pull_properties`).then((resp) => {
        this.setState({
          yardiClient: {
            ...this.state.yardiClient,
            pulling_properties: true,
          },
        });
      });
    };

    handlePullingUnits = () => {
      apiPost(Auth.getApiUrl() + `/landlords/yardi_clients/pull_units`).then((resp) => {
        this.setState({
          yardiClient: {
            ...this.state.yardiClient,
            pulling_units: true,
          },
        });
      });
    };

    triggerYardiOwl = () => {
      apiPost(Auth.getApiUrl() + `/landlords/yardi_clients/trigger_yardi_owl`).then((resp) => {
        this.setState({
          yardiClient: {
            ...this.state.yardiClient,
            pulling_all: true,
          },
        });
      });
    };

    getIntegrations = () => {
      this.setState({ loadingIntegrations: true });
      apiGet(Auth.getApiUrl() + `/landlords/integrations`)
        .then((resp) => {
          this.setState({
            yardiClient: resp.yardi_client_hash,
            loadingIntegrations: false,
          });
        })
        .catch((error) => {
          this.setState({ loadingIntegrations: false });
        });
    };

    render() {
      return (
        <div className="body" role="main">
          <div className="centers" style={{ overflow: 'scroll' }}>
            <div style={{ marginBottom: '50px' }}>
              <div style={{ maxWidth: '720px', margin: '10px auto' }}>
                <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                  <span className="page-title">{getTranslatedString('settings.integrations')}</span>
                </div>
                {this.renderYardiSection()}
              </div>
            </div>
          </div>
        </div>
      );
    }

    renderYardiSection = () => {
      if (this.props.userType !== 'agent') {
        return null;
      }

      const pullingProperties = this.state.yardiClient && this.state.yardiClient.pulling_properties;
      const pullingUnits = this.state.yardiClient && this.state.yardiClient.pulling_units;
      const pullingAll = this.state.yardiClient && this.state.yardiClient.pulling_all;
      const propertiesLastPulledAt =
        this.state.yardiClient && this.state.yardiClient.properties_last_pulled_at;
      const unitsLastPulledAt =
        this.state.yardiClient && this.state.yardiClient.units_last_pulled_at;
      const inactive = !this.state.yardiClient || !this.state.yardiClient.active;

      return (
        <div className="row">
          <Collapsible
            trigger={
              <MenuHeader
                menuTitle={<span>Yardi&nbsp;&nbsp;&nbsp;{this.renderYardiStatusTag()}</span>}
                isOpen={this.state.yardiIsOpen}
                disabled={true}
              />
            }
            style={{ cursor: 'pointer' }}
            open={this.state.yardiIsOpen}
            onOpening={() => this.setState({ yardiIsOpen: true })}
            onClosing={() => this.setState({ yardiIsOpen: false })}
          >
            {this.state.yardiClient && (
              <div>
                <Spacer mb={1} mt={1}>
                  <StyledButton
                    disabled={pullingProperties || inactive}
                    onClick={this.handlePullingProperties}
                  >
                    {getTranslatedString('integrations.pullProperties')}
                    {pullingProperties && <StyledCircularProgress size={20} />}
                  </StyledButton>
                  &nbsp;&nbsp;
                  <StyledButton
                    disabled={pullingUnits || inactive}
                    onClick={this.handlePullingUnits}
                  >
                    {getTranslatedString('integrations.pullUnits')}{' '}
                    {pullingUnits && <StyledCircularProgress size={20} />}
                  </StyledButton>
                  &nbsp;&nbsp;
                  {false && (
                    <StyledButton disabled={pullingAll || inactive} onClick={this.triggerYardiOwl}>
                      {getTranslatedString('integrations.pullAll')}{' '}
                      {pullingAll && <StyledCircularProgress size={20} />}
                    </StyledButton>
                  )}
                </Spacer>
                {(pullingProperties || pullingUnits || pullingAll) && (
                  <Spacer mb={1}>{getTranslatedString('integrations.takesAWhile')}</Spacer>
                )}
                {propertiesLastPulledAt && (
                  <Spacer mb={1}>
                    {getTranslatedString('integrations.propertiesLastPulledAt')}: &nbsp;
                    {toFriendlyDateTimeString(propertiesLastPulledAt)}
                  </Spacer>
                )}
                {unitsLastPulledAt && (
                  <Spacer mb={1}>
                    {getTranslatedString('integrations.unitsLastPulledAt')}: &nbsp;
                    {toFriendlyDateTimeString(unitsLastPulledAt)}
                  </Spacer>
                )}
                <Spacer mb={2}>{this.renderChargeCodeMappingTable()}</Spacer>
              </div>
            )}
            {!this.state.yardiClient && (
              <div>{getTranslatedString('integrations.yardiClientNotFound')}.</div>
            )}
          </Collapsible>
        </div>
      );
    };

    renderYardiStatusTag = () => {
      if (this.state.loadingIntegrations) return null;
      if (this.state.yardiClient?.active) {
        return (
          <StyledTag color="green">{getTranslatedString('integrations.integrationOn')}</StyledTag>
        );
      } else {
        return (
          <StyledTag color="red">{getTranslatedString('integrations.integrationOff')}</StyledTag>
        );
      }
    };

    renderChargeCodeMappingTable = () => {
      if (!this.state.yardiClient) return null;

      const chargeCodeMappingColumns = [
        { title: getTranslatedString('integrations.yuhuValue'), dataIndex: 'yuhu' },
        { title: getTranslatedString('integrations.yardiValues'), dataIndex: 'yardi' },
      ];

      const chargeCodeMappingData = Object.keys(this.state.yardiClient.charge_code_mappings).map(
        (key) => {
          return {
            key: key,
            yuhu: key,
            yardi: this.state.yardiClient.charge_code_mappings[key],
          };
        }
      );

      return (
        <StyledTable
          title={() => getTranslatedString('integrations.chargeCodeMappings')}
          columns={chargeCodeMappingColumns}
          dataSource={chargeCodeMappingData}
          bordered
          pagination={false}
        />
      );
    };
  }
);
